import { render, staticRenderFns } from "./UpdateDocument.vue?vue&type=template&id=493461eb&scoped=true"
import script from "./UpdateDocument.vue?vue&type=script&lang=js"
export * from "./UpdateDocument.vue?vue&type=script&lang=js"
import style0 from "./UpdateDocument.vue?vue&type=style&index=0&id=493461eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493461eb",
  null
  
)

export default component.exports